module.exports = __webpack_public_path__ + "img/network-map - Copia.b494a36e.png";